<template>
    <el-button type="danger" size="small" circle>
        <comTooltip content="Peruuta">
            <el-icon>
                <close />
            </el-icon>
        </comTooltip>
    </el-button>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { Close } from "@element-plus/icons-vue"
import ComTooltip from "../ComTooltip.vue"

export default defineComponent({
    components: {
        Close,
        ComTooltip,
    },
})
</script>
